export default {
      id: "mirror-config-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#mirror-config",
      toString: function () {
        return this.url;
      }
    }